<template>
    <div>
    <download-order :order="order" v-if="theme !== 'dark'" />
        <vue-accordian
                class="order-summary-accordian"
                title="Order Summary"
                :label="formattedDraftSavedDate.toString()"
                :default-open="false"
                :color="theme"
                :openAllButton="theme != 'dark'"
                v-on:open-details="openAllDetails"
                v-on:close-details="closeAllDetails"
        >
            <order-summary-info :order="order"></order-summary-info>

            <div class="flex items-center mt-3">
              <input type="radio" id="sortByEntry" v-model="sortMethod" value="entry" @change="sortPatients" class="mr-2"/>
              <label for="sortByEntry" class="cursor-pointer text-sm mt-0 mb-0">Sort by Order of Entry</label>

                <input type="radio" id="sortAlphabetically" v-model="sortMethod" value="alphabetically" @change="sortPatients" class="mr-2 ml-5"/>
                <label for="sortAlphabetically" class="cursor-pointer text-sm mt-0 mb-0">Sort Alphabetically by Last Name</label>

            </div>
            <!-- Patient list -->
            <order-summary-patient
                v-for="(patient, index) in patients"
                :key="index + redrawComponent"
                :patient="patient"
                :ref="'patient' + index"
                v-on:item-open="accordionOpened"
                v-on:item-close="accordionClosed"
            >
                <!-- Drugs list for single patient -->
                <order-summary-patient-drug
                    v-for="(drug, index2) in patient.drugs"
                    :key="index2"
                    :drug="drug"
                    v-on:delete-drug="confirmDeleteDrug(patient, drug)"
                    v-on:delete-product="confirmDeleteProduct(patient, drug)"
                    :ref="'drugdetails_' + index + '_' + index2 + '_' + redrawComponent"
                    v-on="$listeners"
                    v-on:item-open="accordionOpened"
                    v-on:item-close="accordionClosed"
                ></order-summary-patient-drug>
            </order-summary-patient>

            <!-- Delete drug confirmation modal -->
          <drug-delete-confirm-modal
            :open="deleteDrugModal"
            :drug="removeDrug"
            :patient="removeFromPatient"
            v-on:cancel="closeDeleteModal"
            v-on:delete-success="refreshOrderSummary"
          ></drug-delete-confirm-modal>
          <product-delete-confirm-modal
            :open="deleteProductModal"
            :product="removeProduct"
            :patient="removeFromPatient"
            v-on:cancel="closeDeleteModal"
            v-on:delete-success="refreshOrderSummary"
          ></product-delete-confirm-modal>
        </vue-accordian>
    </div>
</template>

<script>
import OrderService from '@/core/api/order/order.service';
import OrderDrugService from '@/core/api/order/orderDrug.service';

import DownloadOrder from '@/components/order/DownloadOrder.vue';
import OrderSummaryInfo from './OrderSummaryInfo.vue';
import OrderSummaryPatient from './OrderSummaryPatient.vue';
import OrderSummaryPatientDrug from './OrderSummaryPatientDrug.vue';
import DrugDeleteConfirmModal from './DrugDeleteConfirmModal.vue';
import ProductDeleteConfirmModal from './ProductDeleteConfirmModal.vue';

export default {
    name: 'OrderSummary',
    components: {
        OrderSummaryInfo,
        OrderSummaryPatient,
        OrderSummaryPatientDrug,
        DrugDeleteConfirmModal,
        ProductDeleteConfirmModal,
        DownloadOrder,
    },
    data() {
        return {
            order: {},
            patients: [],
            sortMethod: 'entry',
            // Delete drug data
            deleteDrugModal: false,
            deleteProductModal: false,
            removeDrug: {},
            removeProduct: {},
            removeFromPatient: {},
            formattedDraftSavedDate: '',
            allChildrenOpen: false,
            allChildrenClosed: false,
            redrawComponent: 0,
        };
    },
    props: ['theme', 'checkValidDrugs'],
    created() {
        this.getOrderInfo();
    },
    methods: {
        openAll() {
            this.patient.items.forEach((value, index) => {
                const childName = 'drugdetails' + index;
                this.$refs[childName][0].openDetails();
            });
        },
        closeAll() {
            this.patient.items.forEach((value, index) => {
                const childName = 'drugdetails' + index;
                this.$refs[childName][0].closeDetails();
            });
        },
        accordionOpened() {
            this.allChildrenClosed = false;
        },
        accordionClosed() {
            this.allChildrenOpen = false;
        },
        sortPatients() {
            if (this.sortMethod === 'alphabetically') {
                this.patients.sort((a, b) => {
                    if (a.lastName.toLowerCase() < b?.lastName?.toLowerCase()) return -1;
                    if (a.lastName.toLowerCase() > b?.lastName?.toLowerCase()) return 1;
                    return 0;
                });
            } else if (this.sortMethod === 'entry') {
                this.patients = JSON.parse(JSON.stringify(this.order.patients));
            }
        },
        openAllDetails() {
            this.allChildrenOpen = true;
            this.allChildrenClosed = false;

            this.patients.forEach((patient, index) => {
                patient.drugs.forEach((value, index2) => {
                    const childName2 = 'drugdetails_' + index + '_' + index2 + '_' + this.redrawComponent;
                    if (this.$refs[childName2]) {
                        this.$refs[childName2][0].openDetails();
                    }
                });
            });
        },
        closeAllDetails() {
            this.allChildrenOpen = false;
            this.allChildrenClosed = true;

            this.patients.forEach((patient, index) => {
                patient.drugs.forEach((value, index2) => {
                    const childName2 = 'drugdetails_' + index + '_' + index2 + '_' + this.redrawComponent;
                    this.$refs[childName2][0].closeDetails();
                });
            });
        },
       timeConverter(unixTimestamp) {
          const a = new Date(unixTimestamp * 1000);
         const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
         const year = a.getFullYear();
         const month = months[a.getMonth()];
         const date = a.getDate();
         const hour = a.getHours();
         const min = a.getMinutes();
         const time = `${date} ${month} ${year} ${hour}:${min}`;
          return time;
        },
        getOrderInfo() {
            OrderService.orderInfo(this.$route.params.orderId, false).then((data) => {
                this.order = data;
                this.patients = JSON.parse(JSON.stringify(data.patients));

                if (this.order.draftSaved) {
                  this.formattedDraftSavedDate = `Draft saved : ${this.timeConverter(this.order.draftSaved)}`;
                } else {
                  this.formattedDraftSavedDate = '';
                }
                if (this.checkValidDrugs) {
                    this.patients.forEach((p) => {
                        p.drugs.forEach((drug) => {
                            if (drug.reordered) {
                                this.checkSubmissionErrors(drug);
                            }
                        });
                    });
                }
            });
        },
        refreshOrderSummary() {
            this.getOrderInfo();
            this.$emit('refresh-order-summary');
        },
        confirmDeleteDrug(patient, drug) {
            this.removeDrug = drug;
            this.removeFromPatient = patient;
            this.deleteDrugModal = true;
        },
        closeDeleteModal() {
            this.removeDrug = {};
            this.removeProduct = {};
            this.removeFromPatient = {};
            this.deleteDrugModal = false;
            this.deleteProductModal = false;
        },
        confirmDeleteProduct(patient, product) {
            this.removeProduct = product;
            this.removeFromPatient = patient;
            this.deleteProductModal = true;
        },
        async checkSubmissionErrors(drug) {
            let validSubmission = true;
            let orderValidationRef = this.$route.params.orderId + drug.orderLineItemId + 'validationtest';

            let orderValidationData = {
                comment: '',
                deliveryDate: '01/01/2031',
                deliveryTime: '',
                orderRef: orderValidationRef,
            };
            await OrderService.createOrder(orderValidationData)
                .then(async (res) => {
                    orderValidationRef = res.data.orderRef;

                    orderValidationData = {
                        orderRef: orderValidationRef,
                        patientId: 0,
                        quantity: 1,
                        drugPresentationId: drug.drugPresentationId,
                        drug1Dose: drug.drug1Dose,
                        drug2Dose: drug.drug2Dose,
                        containerTypeId: drug.container_type_id,
                        diluentVolume: drug.diluentVolume,
                        diluentExactFinalVolume: drug.diluentExactFinalVolume,
                        treatmentDate: '01/01/2031',
                        deliveryDateArray: drug.deliveryDateArray,
                        onHold: false,
                        adminRouteCode: drug.adminRouteCode,
                        ancillary1Id: drug.ancillary1Id,
                        ancillary2Id: drug.ancillary2Id,
                        infusionTime: drug.infusionTime,
                        infusionTimeDuration: drug.infusionTimeDuration,
                        containerPartCode: drug.containerPartCode,
                        diluent_id: drug.diluent_id,
                        containerId: drug.container_id,
                        type: 'PS',
                    };
                    await OrderDrugService.addDrugForPatient(orderValidationData)
                        .then(async () => {
                            await OrderService.validateOrder({
                                orderRef: orderValidationRef,
                                validateOnly: true,
                            })
                                .then((validationRes) => {
                                    // eslint-disable-next-line no-console
                                    if (validationRes.data.message === 'error') {
                                        let errorMessage = '';
                                        let stabilityError = false;
                                        let drugError = false;
                                        validationRes.data.payload.forEach((value) => {
                                            switch (value) {
                                                case 'VLD-MIS-STABILITY':
                                                    stabilityError = true;
                                                    break;
                                                case 'VLD-TEX-DRUG1DOSE':
                                                case 'VLD-TEX-DRUG2DOSE':
                                                case 'VLD-UNX-ADMINISTRATIONDATE':
                                                    // we dont care about dosage errors
                                                    break;
                                                case 'VLD-GMX-TOTALVOLUME':
                                                case 'VLD-INV-CALCULATEDDILUENTVOLUME':
                                                    errorMessage += 'Drug volume exceeds container size. ';
                                                    drugError = true;
                                                    break;
                                                default:
                                                    errorMessage += 'Unknown error code : ' + value + '. ';
                                                    drugError = true;
                                                    break;
                                            }
                                        });
                                        if (drugError) {
                                            this.patients.forEach((patient, patientIndex) => {
                                                patient.drugs.forEach((checkdrug, drugIndex) => {
                                                    if ((patient.patientId === drug.patientId && (checkdrug.orderLineItemId === drug.orderLineItemId))) {
                                                        this.patients[patientIndex].drugs[drugIndex].editRequired = true;
                                                        this.$emit('editRequired');
                                                        this.$forceUpdate();
                                                        this.redrawComponent += 1;
                                                    }
                                                });
                                            });
                                        }
                                        if (errorMessage.length) {
                                            this.genericErrorText = errorMessage;
                                            validSubmission = false;
                                        } else if (stabilityError) {
                                            if (!this.overrideStability) {
                                                this.showStabilityError = true;
                                                validSubmission = false;
                                            }
                                        }
                                    }
                                });
                            // .catch((err) => {
                            //     if (err.response.status === 400) {
                            //     }
                            // });
                        });
                });



            return validSubmission;
        },
    },
};
</script>
